// export const API_BASE_URL = "http://192.168.29.90:3000/";
export const API_BASE_URL = "https://export-app-backend.onrender.com/";
export const AUTH_TOKEN_KEY = "ACCESS_TOKEN";
export const PUSH_NOTIFICATION_TOKEN_KEY = "PUSH_NOTIFICATION_TOKEN_KEY";
export const USER_DETAILS = "USER_DETAILS";
export const GOOGLE_MAPS_API_KEY = "AIzaSyBANT28yOPlOtvkZzZ1Cdh9wlqm67zyGLQ";
export const STREAM_IO_API_KEY = "mmhfdzb5evj2";
export const STREAM_IO_APP_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwczovL3Byb250by5nZXRzdHJlYW0uaW8iLCJzdWIiOiJ1c2VyL0dyYW5kX01vZmZfVGFya2luIiwidXNlcl9pZCI6IkdyYW5kX01vZmZfVGFya2luIiwidmFsaWRpdHlfaW5fc2Vjb25kcyI6NjA0ODAwLCJpYXQiOjE3NTA0MzM1NTEsImV4cCI6MTc1MTAzODM1MX0.qhRFgbO2mqZMzcRq_N7ioTcAOmYIcWvJxMa22t53kBA";

export const consultationTypes = [
  {
    id: 1,
    label: "In-Clinic Appointments",
    key: "inClinic",
    description: "Consult patients in your clinic.",
    icon: "clinic",
  },
  {
    id: 2,
    label: "Home/Outdoor Visits",
    key: "homeVisit",
    description: "Visit patients at their home or outdoor locations.",
    icon: "home",
  },
  {
    id: 3,
    label: "Video Consultation",
    key: "videoConsultation",
    description: "Consult patients remotely through video call.",
    icon: "video",
  },
  {
    id: 4,
    label: "Tele Consultation",
    key: "teleConsultation",
    description: "Consult patients over the audio call phone.",
    icon: "phone",
  },
  {
    id: 5,
    label: "Chat Consultation",
    key: "chatConsultation",
    description: "Consult patients through chat.",
    icon: "chat",
  },
];

export const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];